import React, { useState, useEffect } from 'react';
import type { LinkPreviewProps, LinkPreviewData } from './types';
import { Preview } from './Preview';
import { LinkPreviewSkeleton } from './Skeleton';
import { fetchMetadata } from '../../utils/metadata';

export const LinkPreview: React.FC<LinkPreviewProps> = ({ url }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<LinkPreviewData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    const controller = new AbortController();

    const getPreviewData = async () => {
      try {
        setLoading(true);
        setError(null);
        const metadata = await fetchMetadata(url);
        if (mounted) {
          setData(metadata);
        }
      } catch (err) {
        if (mounted) {
          setError('Failed to load preview');
          console.error('Error fetching preview:', err);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    if (url) {
      getPreviewData();
    }

    return () => {
      mounted = false;
      controller.abort();
    };
  }, [url]);

  if (loading) {
    return <LinkPreviewSkeleton />;
  }

  if (error) {
    return (
      <div className="w-full max-w-md p-4 bg-red-50 rounded-lg text-red-600">
        {error}
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return <Preview data={data} />;
};